import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from './classroom';
import CLASSROOM_LICENSE_USAGE_FRAGMENT from './classroom-license-usage';
import CLASSROOM_PRIVILEGE_FRAGMENT from './classroom-privilege';
import CLASSROOM_ROLE_FRAGMENT from './classroom-role';
import USER_FRAGMENT from './user';

const USER_CLASSROOM_ENROLLMENT_FRAGMENT = gql`
  fragment BaseUserClassroomEnrollment on UserClassroomEnrollment {
    classroomId
    userId
    user {
      ...BaseUser
    }
    classroom {
      ...BaseClassroom
      licenseUsage {
        ...BaseClassroomLicenseUsage
      }
      organization {
        id
        name
      }
    }
    classroomRoles {
      ...BaseClassroomRole
      privileges {
        ...BaseClassroomPrivilege
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${USER_FRAGMENT}
  ${CLASSROOM_LICENSE_USAGE_FRAGMENT}
  ${CLASSROOM_ROLE_FRAGMENT}
  ${CLASSROOM_PRIVILEGE_FRAGMENT}
`;

export default USER_CLASSROOM_ENROLLMENT_FRAGMENT;
